import { HashRouter, Routes, Route } from 'react-router-dom'

// import * as Sentry from '@sentry/react'

import { AppContext } from '@/main/app/context'
import { appSettings } from '@/main/app/global'

import { CartIndex } from './pages/Cart/CartIndex'
import { Form } from './pages/Form/Form'

import { SidebarCartLayout } from './pages/Sidebar/SidebarCartLayout'
import { SidebarCartIndex } from './pages/Sidebar/SidebarCartIndex'
import { SidebarCartList } from './pages/Sidebar/SidebarCartList'

import { ProfileAndBillingForm } from './pages/Form/ProfileAndBillingForm/ProfileAndBillingForm'
import { DateAndShippingForm } from './pages/Form/DateAndShippingForm/DateAndShippingForm'
import { SubmissionForm } from './pages/Form/SubmissionForm/SubmissionForm'
import { Success } from './pages/Form/Success/Success'
import { MainIndex } from './pages/Main/MainIndex'
import { SidebarIndex } from './pages/Sidebar/SidebarIndex'
import { MainLayout } from './pages/Main/MainLayout'
import { SidebarLayout } from './pages/Sidebar/SidebarLayout'

// const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

function App() {
  const {
    formPaths: [step1, step2, step3],
  } = appSettings

  return (
    <AppContext.Provider value={appSettings}>
      <HashRouter>
        <section className="twc-cart twc-max-w-[1360px]">
          {/* <SentryRoutes> */}
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<MainIndex />} />
              <Route path=":id">
                <Route index element={<CartIndex />} />
                <Route path="form" element={<Form />}>
                  <Route path={`${step1}`} element={<ProfileAndBillingForm />} />
                  <Route path={`${step2}`} element={<DateAndShippingForm />} />
                  <Route path={`${step3}`} element={<SubmissionForm />} />
                  <Route path="success" element={<Success />} />
                </Route>
              </Route>
            </Route>
          </Routes>
          {/* </SentryRoutes> */}

          {/* <SentryRoutes> */}
          <Routes>
            <Route path="/" element={<SidebarLayout />}>
              <Route index element={<SidebarIndex />} />
              <Route path=":id" element={<SidebarCartLayout />}>
                <Route index element={<SidebarCartIndex />} />
                <Route path="form/*" element={<SidebarCartList />} />
              </Route>
            </Route>
          </Routes>
          {/* </SentryRoutes> */}
        </section>
      </HashRouter>
    </AppContext.Provider>
  )
}

export default App
